import { Component, OnInit, AfterViewInit } from '@angular/core';


@Component({
  selector: 'app-base-app',
  templateUrl: './base-app.component.html',
  styleUrls: ['./base-app.component.css']
})

export class BaseAppComponent implements OnInit, AfterViewInit {
    ngAfterViewInit(): void {
      //Talk to
       var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
        (function () {
          var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
          s1.async = true;
          s1.src = 'https://embed.tawk.to/58677a7de7588f12124fb1de/default';
          s1.charset = 'UTF-8';
          s1.setAttribute('crossorigin', '*');
          s0.parentNode.insertBefore(s1, s0);
        })();
    }
     onDeactivate() {
     document.body.scrollTop = 0;
       }


    ngOnInit(): void {
      
    }

}


// WEBPACK FOOTER //
// ./src/app/base-app/base-app.component.ts